import angular from 'angular';

export const componentsModule = angular.module(
  'portainer.azure.react.components',
  []
).name;
